import React from "react";
import './c50_concorsi.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {isMobileOnly} from "react-device-detect";

class Concorsi extends TemplateComponent {

    componentRender(data) {
        return (
            <div id={!isMobileOnly ? 'concorsi' : 'concorsi-mob'}>
                <div className="container concorsi-container">
                    <div className="row">
                        <div className={!isMobileOnly ? 'concorsi-title col-4' : 'concorsi-title'}>{data.title}</div>
                        <div className={!isMobileOnly ? 'concorsi-subtitle col-8' : 'concorsi-subtitle'}>{data.subtitle}</div>
                        <div className="container concorsi-card-container">
                            <div className="row">
                                {data.cards ? data.cards.map((card, index) => (
                                    <div key={index} className={!isMobileOnly ? 'col-6' : 'column-mob'}>
                                        <div className="concorsi-card">
                                            <div className="container-fluid">
                                                <div className="row">
                                                    <div className="concorsi-title">{card.title}</div>
                                                    <div className="concorsi-subtitle">{card.subtitle}</div>
                                                    <div className="concorsi-deadline">
                                                        <span className="concorsi-scadenza-l">Scadenza:</span>
                                                        <span className="concorsi-scadenza-r">{card.deadline}</span>
                                                    </div>
                                                </div>
                                                <div className="container">
                                                    <div className="row flex-column-reverse flex-sm-row">
                                                        <a href={card.left_btn_url} className="col">
                                                            <button className="left-btn">{card.left_btn_title}</button>
                                                        </a>
                                                        <a href={card.right_btn_url} className="col">
                                                            <button
                                                                className="right-btn">{card.right_btn_title}</button>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Concorsi;
